import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import clsx from 'clsx';
import useStyles from './modal.styled';
import { Box, Button, Modal, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';

const MfaModal = ({ open, dialogDescription, setOpenDialog, onConfirm }) => {
  const classes = useStyles();
  return (
    <Modal open={open} className={classes.dialog} aria-labelledby="draggable-dialog-title">
      <Box
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        flexDirection="column"
        display="flex"
        className={classes.dialogContainer}
      >
        <LibraryAddCheckIcon className={classes.icon} data-cy="message-icon-check" />
        <Typography color="textPrimary" component="h2" className={classes.dialogTitle}>
          {i18n.t('authentication.mfa_tab.confirm_action')}
        </Typography>
        <Box className={classes.dialogDescription}>
          <Typography color="textPrimary">{dialogDescription}</Typography>
        </Box>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpenDialog(false)}
            color="primary"
            className={clsx(classes.editButton, classes.dialogButtonLeft)}
          >
            {i18n.t('common.cancel')}
          </Button>
          <Button
            color="primary"
            variant="contained"
            data-cy="edit-btn"
            onClick={() => onConfirm()}
            className={clsx(classes.editButton, classes.dialogButtonRight)}
          >
            {i18n.t('common.confirm')}
          </Button>
        </DialogActions>
      </Box>
    </Modal>
  );
};

MfaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool,
  dialogDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  setOpenDialog: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default MfaModal;
